(function () {
  var $opt = {
    toSlide: 650,
  };

  function slideBlock() {
    var self = this;
    this.isSlide = false;
    this.init = function () {
      this.startSlide();
      this.observerWindow();
    };

    this.startSlide = function () {
      if ($(window).outerWidth(true) > $opt.toSlide) {
        self.isSlide = false;
      } else {
        self.isSlide = true;
      }

      if ('slick' in $.fn && typeof $.fn.slick === 'function') {
        $('.useslider')
          .not('.slick-initialized')
          .slick({
            accessibility: false,
            infinite: false,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            centerMode: true,
            centerPadding: '120px',
            slidesToShow: 1,
            mobileFirst: true,
            responsive: [
              {
                breakpoint: 650,
                settings: 'unslick',
              },
            ],
          });
      }
    };

    this.observerWindow = function () {
      $(window).resize(function () {
        if ($(window).outerWidth(true) > $opt.toSlide) {
          self.isSlide = false;
        } else {
          if (!self.isSlide) {
            self.isSlide = true;
            self.startSlide();
          }
        }
      });
    };
  }

  $(window).on('load', function () {
    new slideBlock().init();
  });
})();
